export interface ContactFormData {
  subject: string
  title: string
  email: string
  phoneNumber: number
  description: string
}

export const createEmptyContactForm = (): ContactFormData => ({
  subject: '',
  title: '',
  email: '',
  phoneNumber: 0,
  description: '',
})